import { NavLink } from 'react-router-dom'
import {
  LayoutDashboard,
  Users,
  Plus,
  type LucideIcon,
} from 'lucide-react'

interface NavItem {
  to: string
  label: string
  icon: LucideIcon
}

const PORTAL_NAV: NavItem[] = [
  { to: '/portal', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/portal/users', label: 'All Users', icon: Users },
  { to: '/portal/provision', label: 'New Copilot', icon: Plus },
]

interface PortalSidebarProps {
  collapsed?: boolean
}

export function PortalSidebar({ collapsed }: PortalSidebarProps) {
  return (
    <aside
      className={`${
        collapsed ? 'w-[60px]' : 'w-[220px]'
      } shrink-0 h-full border-r border-slate-200/60 bg-white dark:bg-slate-800 flex flex-col transition-all overflow-hidden`}
    >
      {!collapsed && (
        <div className="px-5 py-4 border-b border-slate-100">
          <div className="text-xs font-semibold uppercase tracking-[0.06em] text-slate-400">
            Portal
          </div>
        </div>
      )}

      <nav className="flex-1 py-2">
        {PORTAL_NAV.map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/portal'}
            aria-label={collapsed ? item.label : undefined}
            title={collapsed ? item.label : undefined}
            className={({ isActive }) =>
              `flex items-center gap-3 h-[38px] text-[13px] font-medium transition-all border-l-[3px] ${
                collapsed ? 'px-4 justify-center' : 'px-5'
              } ${
                isActive
                  ? 'bg-brand-50/60 border-l-brand-600 text-brand-600 font-semibold'
                  : 'border-l-transparent text-slate-500 hover:bg-slate-50 hover:text-slate-800'
              }`
            }
          >
            <item.icon className="w-[17px] h-[17px] shrink-0" />
            {!collapsed && <span>{item.label}</span>}
          </NavLink>
        ))}
      </nav>
    </aside>
  )
}
